// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.norgie--norgie--XUgG5 {

}

.norgie--norgie--XUgG5::after {
  content: '›';
  font-size: 15px;
  font-weight: bold;
  padding-left: 8px;
  margin-right: 16px;
  transform: rotate(0deg);

  transition-duration: 0.25s;
  transition-property: rotate, transform;
}

.norgie--opened--Hn1zM::after {
  transform: rotate(90deg) translate(-20%, -15%);
}

@media print {
  .norgie--norgie--XUgG5::after {
    content: '';
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/settings/common/norgie.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;;AAEA;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;;EAEvB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n.norgie {\n\n}\n\n.norgie::after {\n  content: '›';\n  font-size: 15px;\n  font-weight: bold;\n  padding-left: 8px;\n  margin-right: 16px;\n  transform: rotate(0deg);\n\n  transition-duration: 0.25s;\n  transition-property: rotate, transform;\n}\n\n.opened::after {\n  transform: rotate(90deg) translate(-20%, -15%);\n}\n\n@media print {\n  .norgie::after {\n    content: '';\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"norgie": `norgie--norgie--XUgG5`,
	"opened": `norgie--opened--Hn1zM`
};
export default ___CSS_LOADER_EXPORT___;
